<template>
  <v-container dark :class="responsivePageStyle" id="loginPage">
    <div>
      <img
        style="width: 75%;"
        id="sonomed"
        alt="Sonomed Escalon"
        src="../assets/Sonomed Escalon Logo for Dark Backgrounds.png"/>
    </div>
    <h1>{{ axisTitle }}</h1>
    <hr class="escalonBlue" />
    <div class="my-4">
      <img
        id="axis-logo"
        alt="Axis Logo"
        :style="imgStyle"
        src="../assets/AXIS Logo for Dark Backgrounds - Grayscale.png"/>
    </div>
    <div v-if="hasAdditionalLoginImage" class="my-4">
      <img
        id="additional-image"
        alt="Additional Image"
        :style="additionalImgStyle"
        :src="additionalLoginImage"/>
    </div>
    <v-row no-gutters>
      <v-col cols="12">
        <v-form v-model="valid" @submit.prevent="submit" class="escalonLoginform">
          <v-text-field
            id="username"
            v-model="username"
            v-validate="'required|max:200'"
            data-vv-as="User ID"
            name="username"
            placeholder="User ID"
            hide-details="auto"
            solo/>
            <span class="fieldErrorMsg">{{ errors.first('username') }}</span>
          <v-text-field
            id="password"
            v-model="password"
            v-validate="'required'"
            data-vv-as="Password"
            name="password"
            placeholder="Password"
            :append-icon="showPassword ? 'fa-eye' : 'fa-eye-slash'"
            :type="showPassword ? 'text' : 'password'"
            hide-details="auto"
            @click:append="showPassword = !showPassword"
            solo/>
            <span class="fieldErrorMsg">{{ errors.first('password') }}</span>
          <div class="mb-3">
            <button class="btn primary-cta" :disabled="submitDisabled">Login</button>
          </div>
          <div class="mb-3">
            <span class="validation-message">{{ loginErrorMsg }}</span>
          </div>
        </v-form>
      </v-col>
    </v-row>
    <hr class="escalonBlue" />
    <v-row no-gutters style="padding-top: 6px;">
      <v-col 
        no-gutters 
        v-if="!isOpenedInApp" 
        cols="12" 
        sm="12"
        class="text-sm-right">
        <img
          class="app-store"
          alt="App Store"
          src="../assets/appStoreDark.png"
          @click="openItunesStore"/>
      </v-col>
    </v-row>
    <v-row no-gutters v-if="!isOpenedInApp">

    </v-row>
    <token-modal :isOpen="is2faOpen" @submit="submit2faModal" @close="close2faModal" />
  </v-container>
</template>

<script>
import tokenModal from "../components/2fa/TokenModal";
import { GoogleAuthenticator } from "../components/2fa/GoogleAuthenticator.js";
import { mapGetters } from "vuex";
import { openPopup } from "../helpers/popup";

export default {
  name: "login-page",
  components: {
    tokenModal
  },
  mixins: [GoogleAuthenticator],
  data() {
    return {
      valid: false,
      username: "",
      password: "",
      loading: false,
      loginErrorMsg: "",
      is2faOpen: false,
      showPassword: false
    };
  },

  computed: {
    ...mapGetters(["axisTitle", "isOpenedInApp", "siteInfo", "heightSm", "heightXs", "heightMd"]),
    submitDisabled() {
      return this.errors.any() || this.loading;
    },
    hasAdditionalLoginImage() {
      if (!this.siteInfo.additionalLoginImage || this.siteInfo.additionalLoginImage == "") 
        return false;
      return true;
    },
    additionalLoginImage() {
      if (!this.siteInfo.additionalLoginImage || this.siteInfo.additionalLoginImage == "") 
        return "";
      var baseURL = window.location.href.split("/");
      baseURL.pop();
      return baseURL.join("/").concat("/" + this.siteInfo.additionalLoginImage);
    },
    responsivePageStyle() {
      if (this.heightSm || this.heightXs)
        return "login-page-small text-center";
      if (this.heightMd)
        return "login-page-medium text-center";
      return "login-page text-center";
    },
    imgStyle() {
      return "width: 75%;"
    },
    additionalImgStyle() {
      return "width: 100%;"
    }
  },
  methods: {
    submit() {
      this.loginErrorMsg = "";
      this.loading = true;
      this.$validator
        .validateAll()
        .then(valid => {
          if (valid)
            return this.$store
              .dispatch("login", { id: this.username, password: this.password })
              .then(response => {
                if (
                  response &&
                  response.data &&
                  response.data.user &&
                  response.data.user.usrMFA
                )
                  this.is2faOpen = true;
                else this.completeLogin();
              })
              .catch(response => {
                if (
                  response &&
                  response.data &&
                  response.data.error_description
                )
                  this.loginErrorMsg = response.data.error_description;
                else
                  this.loginErrorMsg =
                    "An error occurred while logging in. Please try again later.";
              });
        })
        .finally(() => (this.loading = false));
    },
    close2faModal() {
      this.is2faOpen = false;
    },
    submit2faModal(GACode) {
      this.is2faOpen = false;
      this.checkCode(GACode).then(result => {
        if (result) {
          this.completeLogin();
        } else {
          this.loginErrorMsg = "Incorrect 2fa";
        }
      });
    },
    completeLogin() {
      if (this.$route.query.redirect)
        this.$router.push(this.$route.query.redirect);
      else this.$router.push("patients");
    },
    openItunesStore() {
      openPopup("https://apps.apple.com/us/app/axis-image-management/id1496005464");
    }
  },
  mounted() {
    let overlay = window.document.getElementsByClassName("v-overlay");
    if (overlay.length > 0)
      [...overlay].forEach(e => {
        e.parentNode.removeChild(e);
      });
    this.$vuetify.theme.dark = true;
  }
};
</script>

<style lang="scss" scoped>
h1 {
  font-weight: normal;
}
.escalonBlue {
  border-color: #00b0f0;
}
.container {
  max-width: 400px;
}
.login-page {
  padding-top: 5rem;
  padding-left: 24px;
  padding-right: 24px;
}
.login-page-small {
  padding-top: 0.3rem;
  padding-left: 24px;
  padding-right: 24px;
}
.login-page-medium {
  padding-top: 3rem;
  padding-left: 24px;
  padding-right: 24px;
}
#axis-logo {
  width: 240px;
}
#sonomed {
  width: 180px;
}
.app-store {
  width: 115px;
  cursor: pointer;
  height: 85%;
}
.btn {
  width: 135px;
}
.validation-message {
  font-size: 24px;
}
.fieldErrorMsg{
  display: block;
  height: 22px;
  font-size: 12px;
  text-align: left;
  color: #ff5252 !important;
  caret-color: #ff5252 !important;
  line-height: normal;
  word-break: break-word;
  overflow-wrap: break-word;
  word-wrap: break-word;
  -webkit-hyphens: auto;
  -ms-hyphens: auto;
  hyphens: auto;
  padding-left: 13px;
}
</style>
